import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'SettingsAnnouncementEdit',
  props: {
    maintenance: {
      type: Object,
      default: function _default() {
        return {};
      },
      required: true
    },
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      formValid: false,
      createDialogButtons: [{
        icon: 'fas fa-save',
        title: this.$i18n_t('Common.save'),
        type: 'submit'
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }],
      announcement: null
    };
  },
  computed: _objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'color'])),
  watch: {
    maintenance: function maintenance() {
      this.initData();
    }
  },
  mounted: function mounted() {
    this.initData();
  },
  methods: {
    initData: function initData() {
      this.announcement = this.maintenance;
    },
    revalidateForm: function revalidateForm() {
      this.$refs.mainForm.validate();
    },
    handleSubmit: function handleSubmit() {
      this.$emit('save', this.announcement);
    },
    closeDialog: function closeDialog() {
      this.$emit('cancel-edit');
    },
    maintenanceToggleDate: function maintenanceToggleDate() {
      if (!!this.announcement.start && !!this.announcement.end) {
        delete this.announcement.start;
        delete this.announcement.end;
      } else {
        this.announcement.start = new Date();
        this.announcement.end = new Date(new Date() - -7 * 86400 * 1000);
      }

      this.announcement = cloneDeep(this.announcement);
    },
    maintenanceDatePicked: function maintenanceDatePicked(dateObject) {
      this.announcement.start = new Date(dateObject.from * 1000);
      this.announcement.end = new Date(dateObject.to * 1000);
    },
    maintenanceDate: function maintenanceDate(start) {
      return new Date(start) / 1000;
    }
  }
};